import { datadogRum } from '@datadog/browser-rum';
import { PiniaColada } from '@pinia/colada';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { tokenService, marketingSignUpParamsService } from '@tallo/auth';
import { axiosService } from '@tallo/http';
import { AppRouteNames } from '@tallo/investor/navigation';
import { initializeGoogleMapsApi } from '@tallo/property';
import { isReportableRumEvent } from '@tallo/utility';

import App from './App.vue';
import { installPropertyAccessInterceptor } from './property-access.interceptor';
import router from './routes/router';
import { installStaleRoleInterceptor } from './stale-role.interceptor';
import './style.scss';

const app = createApp(App);

// Initialize Google Maps API
initializeGoogleMapsApi(process.env.GOOGLE_MAPS_KEY as string);

if (process.env.DATADOG_ENABLED) {
  datadogRum.init({
    applicationId: process.env.DATADOG_APPLICATION_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'investor-app',
    env: process.env.ENV,
    version: process.env.DATADOG_APP_VERSION || '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    storeContextsAcrossPages: true,
    allowUntrustedEvents: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    beforeSend: isReportableRumEvent,
  });
}

const pinia = createPinia();

pinia.use(() => ({ router }));

app.use(router);
app.use(pinia);
app.use(PiniaColada);

axiosService.setBaseUrl(process.env.API_URL);
axiosService.setAuthToken(tokenService.getToken());
axiosService.setAuthInterceptor(router, { name: AppRouteNames.SIGN_IN });
axiosService.setTimeZoneHeader();
installStaleRoleInterceptor();
installPropertyAccessInterceptor();

marketingSignUpParamsService.captureUtmParams();

app.mount('#root');
